import React, {useRef, useState} from 'react';

import Popup from "reactjs-popup";
import useScroll from "ubs-framework/v2/hooks/useScroll";
import * as Icon from "ubs-icons";
import {COLOR} from "ubs-framework/v2/common/constant";
import {FilterSelect} from "ubs-framework/v2/common/UFilters/FilterSelect/filter-select";
import Select, {components} from "react-select";
import UAvatar from "ubs-framework/v2/UAvatar";
import {getThumbor} from "ubs-framework/v2/common/function";
import {useSelector} from "react-redux";

const SelectJobFilter = React.memo((props) => {
    const popupRef = useRef(null)
    const [name, setName] = useState('')

    const _S3_BASE_URL = useSelector(e => e.common.S3_BASE_URL);

    const handle = {
        blur: e => {
            if (name) props?.onChange(name)
        },
        changeName: (e, type) => {
            setName(e?.value)
        },
        clearData: e => {
            e.stopPropagation()
            props?.onChange('')
            if (popupRef?.current) popupRef?.current?.open()
        }
    }

    useScroll(document.getElementsByClassName('u_import-scroll')[0], (e) => {
        if (popupRef.current) popupRef.current.close()
    });

    return (
        <React.Fragment>
            <Popup
                ref={popupRef}
                trigger={open => (
                    <div className="u_import-data-input">
                        <p className="u_small-font u_cp  u_flex u_align-center" onClick={(e) => handle.clearData(e)}>
                            <span className="u_mr-5 u_flex-1">{props?.errorTitle?.label || props?.placeholder}</span>
                            <Icon.DownArrow fill={COLOR.u_title} size={14}/>
                        </p>
                    </div>
                )}
                position="bottom center"
                closeOnDocumentClick
                closeOnEscape
                className="u_popover-container"
                arrow={false}
                contentStyle={{zIndex: 10001}}
                onClose={handle.blur}
            >
                <Select
                    name="job"
                    className="u_label-input-select-inner"
                    classNamePrefix="u_select"
                    placeholder=" "
                    isClearable={true}
                    value={props?.errorTitle ?? null}
                    onInputChange={props?.onInputChange}
                    onChange={e => props?.onChange(e)}
                    options={props?.option}
                    noOptionsMessage={() => props?.allValues?.searchEmpText?.length < 3 ? 'Type three character to search job name.' : props?.isLoading ? 'Loading...' : 'No Record Found'}
                    menuPosition="fixed"
                    filterOption={options => options}
                    onKeyDown={e => {
                        if ((e.keyCode === 32 || e.keyCode === 8 || e.keyCode === 9) && !e.target.value) e.preventDefault();
                    }}
                    components={{
                        Option: (props) => (
                            <components.Option {...props}>
                                <div className="u_filter-employee-info">
                                    <UAvatar name={props?.data?.label} width={24} thumbor={getThumbor('32x32')}
                                             image={props?.data?.profileImage} s3Url={_S3_BASE_URL}/>
                                    <p className="u_one-line">{props?.data?.label}</p>
                                </div>
                            </components.Option>
                        ),
                        SingleValue: (props) => (
                            <components.SingleValue {...props}>
                                <div className="u_filter-employee-info">
                                    <UAvatar name={props?.data?.label} width={24} thumbor={getThumbor('32x32')}
                                             image={props?.data?.profileImage} s3Url={_S3_BASE_URL}/>
                                    <p className="u_one-line">{props?.data?.label}</p>
                                </div>
                            </components.SingleValue>
                        ),
                    }}
                />
            </Popup>
        </React.Fragment>
    );
});

export default SelectJobFilter;
